import Route from "@ember/routing/route";

export default class PrivateNetworksDetailsRoute extends Route {
  async model(params) {
    let { project } = this.modelFor("organization");
    let privateNetworks = await project.get("privateNetworks");
    let privateNetwork = privateNetworks.find((privateNetwork) => privateNetwork.id === params.private_network_id);

    return {
      project,
      privateNetwork,
    };
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.pollStatusLoop.perform(model.privateNetwork);
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.pollStatusLoop.cancelAll();
  }
}
